import { BoltToken } from '~/components/ui/icons/BoltToken';
import type { Pricing } from '~/utils/pricing';

export const PlanBlock = ({ pricing }: { pricing?: Pricing }) => {
  if (!pricing) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 items-start h-full">
      <div className="max-w-[428px] pr-0 sm:pr-8 text-bolt-ds-textPrimary flex-1 overflow-y-auto flex flex-col gap-3 rounded-xl">
        <div className="text-xl font-semibold">Selected plan</div>

        <div className="font-semibold text-4xl">{pricing.plan === 'pro' ? 'Pro' : 'Teams'}</div>
        <div className="flex gap-2 items-center">
          <BoltToken className="size-8" />
          <div className="text-lg">{pricing.tokens} per month</div>
        </div>
        {pricing.features && (
          <>
            <div className="mt-5">You get:</div>
            <div className="flex flex-col gap-2 mb-4 text-bolt-ds-textSecondary">
              {pricing.features.map((feature) => (
                <div key={feature} className="flex items-start gap-2">
                  <div className="size-5 mt-0.5 i-heroicons:check-solid" />
                  <div className="mt-1">{feature}</div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
